export var StoreHeadlessDialogUrl = 'https://teams.microsoft.com/extensibility-apps/appdetails/{0}/create?metaoshost=office&host=metaos&language={1}';
export var StoreAppId = 'apps';
export var HeadlessDialogConstants = {
    height: 610,
    width: 900,
};
//# sourceMappingURL=constants.js.map